/* eslint-disable implicit-arrow-linebreak */
import { useQuery } from '@tanstack/react-query';
import BenefitsService from 'src/services/benefits.service';

// eslint-disable-next-line no-unused-vars
export const useBenefitPremiumPayout = (params: { versionId: string }) => {
  const result = useQuery({
    queryKey: ['benefits/premium'],
    queryFn: () => BenefitsService.getBenefitPremiumPayout(params),
    enabled: true,
  });
  return result;
};
